import React from 'react';
import { BannerSection } from '../HomeComponents/BannerSection';
import { OurLuxurySection } from '../HomeComponents/OurLuxurySection';
import { CharterOfferSection } from '../HomeComponents/CharterOfferSection';
import { EmpoweringSection } from '../HomeComponents/EmpoweringSection';
import { OurGallerySection } from '../HomeComponents/OurGallerySection';
import BookingHome from '../../Sections/BookingHome';
import FAQItem from '../FAQS/Faqs';

const Home = () => {
  return (
    <>
      <BannerSection />
      <OurLuxurySection/>
      <BookingHome />
      <CharterOfferSection/>
      <EmpoweringSection/>
      <OurGallerySection/>
      {/* <FAQItem /> */}
    </>
  );
};

export default Home;
